var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.model)?_c('blocking-loader',{attrs:{"show":_vm.loading}},[_vm._v(" Pobieranie podglądu ")]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }